// extracted by mini-css-extract-plugin
export default {"hero":"Hero3_hero__XEHit","images":"Hero3_images__fZg6i","image":"Hero3_image__CJ09U","textOverlay":"Hero3_textOverlay__Gturg","title":"Hero3_title__zprh+"};